module.exports = __webpack_public_path__ + "img/zaniks-crate.9b99d230.png";